import React from "react";
import {getLoanLibraryLoanStatusTextByValue} from "../../../Loan/LoanLibrary/LoanManagement/loanLibraryLoanUtility";

interface LoanLibraryHistoryRowProps {
    loanHistory: Record<string, any>;
}

export const LoanLibraryHistoryRow = ({loanHistory}: LoanLibraryHistoryRowProps) => {
    const getStatusBadge = () => {
        if (loanHistory.isOverdue && !loanHistory.dateReturned) {
            return <span className="badge badge--error">Overdue ({loanHistory.daysOverdue} days)</span>;
        }
        return getLoanLibraryLoanStatusTextByValue(loanHistory.loanLibraryLoanStatus);
    };

    return (
        <tr data-testid={`loan-history-row-${loanHistory.loanId}`}>
            <td>{loanHistory.catalogNumber}</td>
            <td>{loanHistory.catalogItemTitle}</td>
            <td>{loanHistory.serialNumber}</td>
            <td>{loanHistory.patronFullName}</td>
            <td>{loanHistory.shippingLocationName}</td>
            <td>{loanHistory.checkedOutDateFormatted}</td>
            <td>{loanHistory.dueDateFormatted}</td>
            <td>{loanHistory.dateReturnedFormatted || "-"}</td>
            <td>{getStatusBadge()}</td>
        </tr>
    );
};
